import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Home from "../../pages/Home/Home";
import "./Navbar.css";
import Scroll from "react-scroll";
import { Button } from "react-bootstrap";
const ScrollLink = Scroll.ScrollLink;

const mobileNavToogle = () => {
  const mobileNavShow = document.querySelector(".mobile-nav-show");
  const mobileNavHide = document.querySelector(".mobile-nav-hide");

  document.querySelector("body").classList.toggle("mobile-nav-active");
  mobileNavShow.classList.toggle("d-none");
  mobileNavHide.classList.toggle("d-none");
};

const mobileNavlink = () => {
  if (document.querySelector(".mobile-nav-active")) {
    mobileNavToogle();
  }
};

const navDropdowns = () => {
  if (document.querySelector(".mobile-nav-active")) {
    this.classList.toggle("active");
    this.nextElementSibling.classList.toggle("dropdown-active");

    let dropDownIndicator = this.querySelector(".dropdown-indicator");
    dropDownIndicator.classList.toggle("bi-chevron-up");
    dropDownIndicator.classList.toggle("bi-chevron-down");
  }
};

const Navbar = () => {
  const [ServiceDropdown, toggleServiceDropdown] = useState(false);
  const [aboutDropdown, toggleAboutDropdown] = useState(false);
  const [ITDropdown, toggleITDropdown] = useState(false);
  const [ProductDropdown, toggleProductDropdown] = useState(false);
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const navToggle = (e) => {
    e.preventDefault();
    mobileNavToogle();
  };

  const NavVisibility = () => {
    if (window.scrollY > 1) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", NavVisibility);

    return () => {
      window.removeEventListener("scroll", NavVisibility);
    };
  });

  return (
    <>
      <header
        id="header"
        className={`header d-flex align-items-center ${show && "nav-black"}  `}
      >
        <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
          <Link to={"/"} className="logo d-flex align-items-center">
            <img src="../assets/img/about.jpg" />
          </Link>

          <i
            onClick={navToggle}
            className="mobile-nav-toggle mobile-nav-show bi bi-list"
          ></i>
          <i
            onClick={navToggle}
            className="mobile-nav-toggle mobile-nav-hide d-none bi bi-x"
          ></i>
          <nav id="navbar" className="navbar">
            <ul>
              <li onClick={mobileNavlink}>
                <NavLink id="home" to={"/"}>
                  Home
                </NavLink>
              </li>
              <li onClick={mobileNavlink}>
                <NavLink id="home" to={"/about"}>
                  About
                </NavLink>
              </li>
              <li onClick={mobileNavlink}>
                <NavLink id="home" to={"/data-protection"}>
                  Data Protection
                </NavLink>
              </li>
              <li onClick={mobileNavlink}>
                <NavLink id="home" to={"/sdgs-and-alignment"}>
                  SDGs and Alignment
                </NavLink>
              </li>
              <li onClick={mobileNavlink}>
                <NavLink id="home" to={"/membership"}>
                  Membership
                </NavLink>
              </li>{" "}
              <li onClick={mobileNavlink}>
                <NavLink id="home" to={"/collaboration"}>
                  Collaboration
                </NavLink>
              </li>
              <li>
                <Button onClick={() => navigate("/login")} className="batun">
                  Login
                </Button>
                <i
                  className="fa fa-circle-user"
                  style={{ fontSize: "25px", color: "#f99f30" }}
                  onClick={() => navigate("/account")}
                ></i>
              </li>
              {/* <li className="dropdown">
                <NavLink
                  to={`${process.env.PUBLIC_URL}/services`}
                  id="services"
                  href="#"
                  onClick={(e) => {
                    toggleServiceDropdown(!ServiceDropdown);
                    e.preventDefault();
                  }}
                >
                  <span>Services</span>
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </NavLink>
                <ul className={`${ServiceDropdown && "dropdown-active"}  `}>
                  <li onClick={mobileNavlink}>
                    <Link to={`${process.env.PUBLIC_URL}/services`}>
                      All Services
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link to={`${process.env.PUBLIC_URL}/consultancy`}>
                      Consultancy
                    </Link>
                  </li>
                  <li
                    className="dropdown"
                    onClick={() => toggleITDropdown(!ITDropdown)}
                  >
                    <Link to={"IT-audit"} onClick={(e) => e.preventDefault()}>
                      <span>IT Audit</span>
                      <i className="bi bi-chevron-down dropdown-indicator"></i>
                    </Link>
                    <ul
                      className={`${ITDropdown && "dropdown-active"}  `}
                      onClick={mobileNavlink}
                    >
                      <li onClick={mobileNavlink}>
                        <Link to={`${process.env.PUBLIC_URL}/IT-audit`}>
                          IT General Control Reviews
                        </Link>
                      </li>
                      <li>
                        <Link to={`${process.env.PUBLIC_URL}/IT-audit`}>
                          IT Applications Control Reviews
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link
                      to={`${process.env.PUBLIC_URL}/disaster-recovery-strategy`}
                    >
                      Disaster Recovery Strategy
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link
                      to={`${process.env.PUBLIC_URL}/business-continuity-plan`}
                    >
                      Business Continuity Plan
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link
                      to={`${process.env.PUBLIC_URL}/database-and-network-audit`}
                    >
                      Database and Network Audit
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link to={`${process.env.PUBLIC_URL}/software-development`}>
                      Software Development
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link
                      to={`${process.env.PUBLIC_URL}/data-protection-audit`}
                    >
                      Data Protection Audit
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link
                      to={`${process.env.PUBLIC_URL}/data-protection-implementation`}
                    >
                      Data Protection Implementation
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link
                      to={`${process.env.PUBLIC_URL}/data-protection-training`}
                    >
                      Data Protection Training
                    </Link>
                  </li>
                  <li onClick={mobileNavlink}>
                    <Link
                      to={`${process.env.PUBLIC_URL}/data-audit-report-filing`}
                    >
                      Data Audit Report Filing
                    </Link>
                  </li>
                </ul>
              </li> */}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Navbar;
